import { customerTranslations } from "../context/customertranslations.js";

const baseTranslations = {
  vi: {
    // Navbar
    "my_stations_nav": "Trạm của tôi",
    "account": "Tài khoản",
    "personal_info": "Thông tin cá nhân",
    "my_orders": "Đơn hàng của tôi",
    "change_password": "Đổi mật khẩu",
    "logout": "Đăng xuất",
    "logging_out": "Đang đăng xuất...",
    "login": "Đăng nhập",
    "cart": "Giỏ hàng",
    "categories": "Danh mục",
    "home": "Trang chủ",
    "station_mixer": "Trạm trộn",
    "products": "Sản phẩm",
    "equipment_group": "Cụm thiết bị",
    "introduction": "Giới thiệu",
    "purchase_policy": "Chính sách mua hàng",
    "contact_us": "Liên hệ",
    "dashboard": "Cụm thiết bị",
    "quick_links": "Liên kết nhanh",
    "policies": "Chính sách",
    "copyright": "Bản quyền thuộc về TTSmart. Bảo lưu mọi quyền.",

    // Dashboard
    "loading_banner": "Đang tải banner...",
    "loading_sections": "Đang tải sections...",
    "loading_partners": "Đang tải đối tác...",
    "partners": "Đối tác",
    "error_prefix": "Lỗi: ",
    "price_unavailable": "Giá không có sẵn",

    // Products / Filters
    "search_products": "Tìm kiếm sản phẩm",
    "select_mixing_station": "Chọn trạm trộn",
    "all_my_stations": "Tất cả trạm của tôi",
    "search_by_name": "Tìm kiếm theo tên",
    "search_by_brand": "Tìm kiếm thương hiệu",
    "all_brands": "Tất cả thương hiệu",
    "search_by_type": "Tìm kiếm loại sản phẩm",
    "all_types": "Tất cả loại sản phẩm",
    "search_by_section": "Tìm kiếm theo mục",
    "all_sections": "Tất cả mục",
    "search_by_equipment": "Tìm kiếm theo thiết bị",
    "all_equipment": "Tất cả thiết bị",
    "sort_by": "Sắp xếp theo",
    "created_date": "Ngày tạo",
    "rating": "Đánh giá",
    "purchases": "Lượt mua",
    "descending": "Giảm dần",
    "ascending": "Tăng dần",
    "search": "Tìm kiếm",
    "filters": "Bộ lọc",
    "product_filters": "Bộ lọc sản phẩm",
    "login_to_view_station_items": "Vui lòng đăng nhập để xem các thiết bị / vật liệu thuộc trạm trộn của bạn.",
    "login_now": "Đăng nhập ngay",
    "no_stations_configured": "Tài khoản của bạn chưa được cấp trạm trộn nào. Vui lòng liên hệ Admin để được cấu hình trạm.",
    "no_items_configured": "Trạm trộn của bạn chưa được cấu hình thiết bị nào, hoặc bộ lọc không tìm thấy sản phẩm phù hợp.",

    // Product Display
    "loading_product_details": "Đang tải chi tiết sản phẩm...",
    "product_not_found": "Sản phẩm không tìm thấy.",
    "product_does_not_exist": "Sản phẩm không tồn tại",
    "failed_to_load_product": "Không thể tải thông tin sản phẩm",
    "failed_to_load_reviews": "Không thể tải đánh giá sản phẩm",
    "login_to_add_cart": "Vui lòng đăng nhập để thêm sản phẩm vào giỏ hàng!",
    "login_to_review": "Vui lòng đăng nhập để đánh giá sản phẩm!",
    "review_submitted": "Đánh giá sản phẩm thành công",
    "review_updated": "Đã cập nhật đánh giá",
    "review_deleted": "Đánh giá đã được xóa!",
    "failed_to_submit_review": "Không thể gửi đánh giá",
    "failed_to_delete_review": "Không thể xóa đánh giá",
    "product_description": "Mô tả sản phẩm",
    "specifications": "Thông số kỹ thuật",
    "reference_documents": "Tài liệu tham khảo",
    "other_documents": "Tài liệu khác",
    "features": "Tính năng",
    "operating_method": "Cách hoạt động",
    "advantages": "Ưu điểm",
    "no_reviews_yet": "Chưa có đánh giá nào",
    "comment": "Bình luận",
    "processing": "Đang xử lý...",
    "update_review": "Cập nhật đánh giá",
    "submit_review": "Gửi đánh giá",
    "delete_review": "Xóa đánh giá",
    "customer_support": "Chăm sóc khách hàng",
    "hotline": "Đường dây nóng",
    "contact_zalo": "Liên hệ qua Zalo",
    "send_email": "Gửi Email",
    "faqs": "Vấn đề thường gặp",
    "return_warranty": "Đổi trả & Bảo hành",
    "genuine_100": "100% Chính hãng",
    "genuine_warranty_label": "Tem bảo hành chính hãng",
    "return_3_days": "3 ngày đổi trả",
    "out_of_stock": "Trạng thái: Liên hệ",
    "quantity_left": "Số lượng đang còn: ",
    "add_to_cart": "Thêm vào giỏ hàng",
    "quantity": "Số lượng",
    "image": "Hình ảnh",
    "product_name": "Tên sản phẩm",

    // Cart
    "cart_empty": "Giỏ hàng của bạn hiện tại trống.",
    "login_to_order": "Bạn cần phải đăng nhập để đặt hàng",
    "no_items_selected": "Bạn chưa chọn sản phẩm nào để đặt hàng!",
    "insufficient_stock": "Không đủ hàng cho sản phẩm {name}, chỉ còn {qty} sản phẩm.",
    "order_success": "Đặt hàng thành công",
    "clear_cart": "Xóa giỏ hàng",
    "place_order": "Đặt hàng",
    "confirm_clear_cart": "Xác nhận xóa giỏ hàng",
    "confirm_clear_cart_msg": "Bạn có chắc chắn muốn xóa toàn bộ giỏ hàng không?",
    "cancel": "Hủy",
    "clear": "Xóa",
    "price": "Giá",
    "attributes": "Thuộc tính",
    "no_product_info": "Không tìm thấy thông tin sản phẩm.",
    "product_unavailable": "Sản phẩm không khả dụng cho tài khoản hoặc trạm hiện tại.",
    "remove_unavailable_product": "Hãy xóa sản phẩm này khỏi giỏ hàng.",
    "contact_only_product": "Sản phẩm này hiện chỉ nhận liên hệ.",
    "min_qty_warning": "Số lượng tối thiểu là 1!",
    "max_qty_warning": "Số lượng tối đa là ",
    "insufficient_stock_general": "Không còn đủ số lượng hàng để đặt thêm",
    "total": "Tổng:",

    // My Orders
    "orders_list": "Danh sách đơn hàng",
    "login_to_view_orders": "Bạn chưa đăng nhập! Vui lòng đăng nhập để xem đơn hàng.",
    "session_expired": "Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại!",
    "error_loading_orders": "Lỗi khi tải đơn hàng: ",
    "cancel_order_failed": "Hủy đơn hàng thất bại!",
    "cancel_order_success": "Hủy đơn hàng thành công!",
    "cancelled": "Đã hủy",
    "state_processing": "Đang xử lý",
    "delivering": "Đang giao hàng",
    "completed": "Hoàn thành",
    "no_processing_orders": "Không có đơn hàng nào đang xử lý.",
    "no_delivering_orders": "Không có đơn hàng nào đang được giao.",
    "no_completed_orders": "Không có đơn hàng nào đã hoàn thành.",
    "no_cancelled_orders": "Không có đơn hàng nào bị hủy.",
    "no_orders_yet": "Bạn chưa có đơn hàng nào.",
    "all": "Tất cả",
    "login_to_view_orders_table": "Đăng nhập để xem danh sách đơn hàng.",
    "order_code": "Mã đơn",
    "order_date": "Ngày đặt",
    "total_money": "Tổng tiền",
    "payment": "Thanh toán",
    "status": "Trạng thái",
    "paid": "Đã thanh toán",
    "unpaid": "Chưa thanh toán",
    "order_details": "Chi tiết đơn hàng",
    "order_code_label": "Mã đơn hàng:",
    "product_list": "Danh sách sản phẩm:",
    "cancel_order": "Hủy đơn hàng",
    "close": "Đóng",
    "confirm_cancel_order": "Xác nhận hủy đơn hàng",
    "confirm_cancel_order_msg": "Bạn có chắc chắn muốn hủy đơn hàng {id} không?",
    "no": "Không",
    "yes": "Có",

    // Profile & Password
    "full_name": "Họ và tên",
    "phone_number": "Số điện thoại",
    "email_address": "Địa chỉ email",
    "address": "Địa chỉ",
    "save_changes": "Lưu thay đổi",
    "current_password": "Mật khẩu hiện tại",
    "new_password": "Mật khẩu mới",
    "confirm_new_password": "Xác nhận mật khẩu mới",
    "passwords_do_not_match": "Mật khẩu mới không trùng khớp!",

    // Station
    "my_station": "Trạm của tôi",
    "station_not_found": "Không tìm thấy trạm",
    "stations_list": "Danh sách trạm trộn",
    "select_station_continue": "Vui lòng chọn trạm trộn để tiếp tục",

    // Database translations
    "CẢM BIẾN": "CẢM BIẾN",
    "ĐỘNG CƠ HỘP SỐ": "ĐỘNG CƠ HỘP SỐ",
    "THIẾT BỊ ĐIỆN": "THIẾT BỊ ĐIỆN",
    "XILANH KHÍ NÉN": "XILANH KHÍ NÉN",
    "HỆ THỐNG CÂN LỌC BỤI": "HỆ THỐNG CÂN LỌC BỤI",
    "PHỤ KIỆN TRẠM TRỘN": "PHỤ KIỆN TRẠM TRỘN",
    "VẬT LIỆU": "VẬT LIỆU",
    "CÁNH TAY BỘ TRỘN": "CÁNH TAY BỘ TRỘN",
    "PHỤ KIỆN BÊ TÔNG": "PHỤ KIỆN BÊ TÔNG",
    "TỦ ĐIỆN ĐIỀU KHIỂN": "TỦ ĐIỆN ĐIỀU KHIỂN",
    "CỤM TRUNG TÂM": "CỤM TRUNG TÂM",
    "CỤM BĂNG": "CỤM BĂNG",
    "CỤM CỐI": "CỤM CỐI",
    "CỤM CỐT LIỆU": "CỤM CỐT LIỆU",
    "CỤM SILO": "CỤM SILO",
    "TRẠM TRỘN BÊ TÔNG": "TRẠM TRỘN BÊ TÔNG",

    "already_have_account_login": "Đã có tài khoản? Đăng nhập ngay",
    "dont_have_account_register": "Chưa có tài khoản? Đăng ký ngay",

    // Missing UI translations
    "location": "Vị trí",
    "failed_to_get_user_stations": "Không thể lấy trạm người dùng",
    "failed_to_get_station_info": "Không thể lấy thông tin trạm",
    "login_to_view_stations": "Bạn cần đăng nhập để hiển thị danh sách trạm.",
    "no_stations_yet": "Không có trạm nào",
    "station_image": "Ảnh trạm",
    "station_name": "Tên trạm",
    "station_code": "Mã trạm",
    "product_count": "Số sản phẩm",
    "details": "Chi tiết",
    "footer_brand_desc": "TTSmart - Giải pháp tự động hóa, thiết bị đo lường và vật tư trạm trộn bê tông hàng đầu.",
    "footer_address": "Số 28/29 Vũ Đức Thận, Việt Hưng, Long Biên, Hà Nội",
    "connect_with_us": "Kết nối với chúng tôi",
    "failed_to_load_profile": "Không thể tải thông tin hồ sơ",
    "update_failed": "Cập nhật thất bại",
    "update_success": "Cập nhật thông tin thành công!",
    "fill_all_address_fields": "Vui lòng điền đầy đủ các thông tin địa chỉ!",
    "failed_to_save_address": "Không thể lưu địa chỉ",
    "update_address_success": "Cập nhật địa chỉ thành công!",
    "add_address_success": "Thêm địa chỉ thành công!",
    "confirm_delete_address": "Bạn có chắc chắn muốn xóa địa chỉ này?",
    "failed_to_delete_address": "Không thể xóa địa chỉ",
    "delete_address_success": "Xóa địa chỉ thành công!",
    "failed_to_set_default_address": "Không thể thiết lập địa chỉ mặc định",
    "set_default_address_success": "Đã đặt làm địa chỉ mặc định!",
    "account_info": "Thông tin tài khoản",
    "phone_number_used_for_login": "Số điện thoại dùng làm thông tin tài khoản đăng nhập",
    "not_updated_yet": "Chưa cập nhật",
    "address_book": "Sổ địa chỉ công trình / nhận hàng",
    "add_address": "Thêm địa chỉ",
    "no_addresses_saved": "Chưa có địa chỉ công trình nào được lưu. Địa chỉ nhập khi đặt hàng đầu tiên sẽ được tự động lưu vào đây.",
    "receiver": "Người nhận",
    "edit_construction_address": "Chỉnh sửa địa chỉ công trình",
    "add_construction_address": "Thêm địa chỉ công trình mới",
    "address_label_placeholder": "Tên gợi nhớ (Ví dụ: Công trình A, Văn phòng, Dự án B)",
    "receiver_name": "Tên người nhận thiết bị",
    "receiver_phone": "Số điện thoại người nhận",
    "address_detail_label": "Địa chỉ chi tiết công trình nhận hàng",
    "save_address": "Lưu địa chỉ",
    "passwords_do_not_match_signup": "Mật khẩu không khớp",
    "phone_validation_msg": "Số điện thoại phải có đúng 10 chữ số",
    "email_required_msg": "Vui lòng nhập email",
    "email_validation_msg": "Email không đúng định dạng",
    "register_success": "Đăng ký thành công",
    "login_identifier_required": "Vui lòng nhập số điện thoại hoặc email",
    "login_identifier_invalid": "Vui lòng nhập đúng số điện thoại (10 số) hoặc địa chỉ email",
    "login_success": "Đăng nhập thành công",
    "invalid_credentials": "Số điện thoại/Email hoặc mật khẩu không đúng",
    "forgot_identifier_required": "Vui lòng nhập số điện thoại hoặc email",
    "otp_sent_success": "Mã OTP đã được gửi",
    "otp_invalid": "Vui lòng nhập mã OTP gồm 6 chữ số",
    "reset_password_success": "Đặt lại mật khẩu thành công",
    "create_account": "Tạo tài khoản",
    "out_of_stock_val": "Liên hệ",
    "quantity_left_val": "Còn lại: ",
    "contact_phone": "Liên hệ: 0813 158 383",
    "add_to_cart_short": "Thêm vào giỏ",
    "password": "Mật khẩu",
    "confirm_password": "Xác nhận mật khẩu",
    "register": "Đăng ký",
    "forgot_password_title": "Quên mật khẩu",
    "forgot_password_desc": "Nhập số điện thoại hoặc email của bạn để nhận mã OTP khôi phục mật khẩu.",
    "phone_or_email": "Số điện thoại hoặc Email",
    "otp_email_note": "Lưu ý: Mã OTP sẽ gửi về email đăng ký của khách hàng. OTP có hiệu lực trong vòng 5 phút!",
    "send_otp": "Gửi mã OTP",
    "back_to_login": "Quay lại đăng nhập",
    "reset_password_title": "Đặt lại mật khẩu",
    "otp_sent_to": "Mã OTP đã được gửi đến email liên kết của tài khoản:",
    "otp_placeholder": "Nhập mã OTP 6 số",
    "confirm_reset": "Xác nhận",
    "back": "Quay lại",
    "forgot_password": "Quên mật khẩu?",
    "welcome": "Chào mừng!",
    "fill_to_register": "Hãy điền thông tin để tạo tài khoản",
    "hello": "Xin chào!",
    "login_to_use_all_features": "Hãy đăng nhập để sử dụng hết các tính năng"
  },
  zh: {
    // Navbar
    "my_stations_nav": "我的站点",
    "account": "账户",
    "personal_info": "个人信息",
    "my_orders": "我的订单",
    "change_password": "修改密码",
    "logout": "退出登录",
    "logging_out": "正在退出...",
    "login": "登录",
    "cart": "购物车",
    "categories": "类目",
    "home": "首页",
    "station_mixer": "搅拌站",
    "products": "产品",
    "equipment_group": "设备组",
    "introduction": "关于我们",
    "purchase_policy": "采购政策",
    "contact_us": "联系我们",
    "dashboard": "设备组",
    "quick_links": "快速链接",
    "policies": "政策法规",
    "copyright": "版权所有 © TTSmart. 保留所有权利。",

    // Dashboard
    "loading_banner": "正在加载轮播图...",
    "loading_sections": "正在加载栏目...",
    "loading_partners": "正在加载合作伙伴...",
    "partners": "合作伙伴",
    "error_prefix": "错误: ",
    "price_unavailable": "暂无价格",

    // Products / Filters
    "search_products": "搜索产品",
    "select_mixing_station": "选择搅拌站",
    "all_my_stations": "我的所有站点",
    "search_by_name": "按名称搜索",
    "search_by_brand": "品牌搜索",
    "all_brands": "所有品牌",
    "search_by_type": "产品类型搜索",
    "all_types": "所有类型",
    "search_by_section": "按栏目搜索",
    "all_sections": "所有栏目",
    "search_by_equipment": "按设备搜索",
    "all_equipment": "所有设备",
    "sort_by": "排序方式",
    "created_date": "创建日期",
    "rating": "评分",
    "purchases": "销量",
    "descending": "降序",
    "ascending": "升序",
    "search": "搜索",
    "filters": "筛选器",
    "product_filters": "产品筛选",
    "login_to_view_station_items": "请登录后查看您的搅拌站所拥有的设备/物料。",
    "login_now": "立即登录",
    "no_stations_configured": "您的账户尚未分配任何搅拌站。请联系管理员进行配置。",
    "no_items_configured": "您的搅拌站尚未配置任何设备，或筛选未找到匹配的产品。",

    // Product Display
    "loading_product_details": "正在加载产品详情...",
    "product_not_found": "未找到该产品。",
    "product_does_not_exist": "产品不存在",
    "failed_to_load_product": "无法加载产品信息",
    "failed_to_load_reviews": "无法加载产品评价",
    "login_to_add_cart": "请登录后再将产品加入购物车！",
    "login_to_review": "请登录后再评价产品！",
    "review_submitted": "评价产品成功",
    "review_updated": "评价已更新",
    "review_deleted": "评价已删除！",
    "failed_to_submit_review": "无法提交评价",
    "failed_to_delete_review": "无法删除评价",
    "product_description": "产品描述",
    "specifications": "规格参数",
    "reference_documents": "参考文档",
    "other_documents": "其他文档",
    "features": "特性/功能",
    "operating_method": "工作原理",
    "advantages": "产品优势",
    "no_reviews_yet": "暂无评价",
    "comment": "评论",
    "processing": "处理中...",
    "update_review": "更新评价",
    "submit_review": "提交评价",
    "delete_review": "删除评价",
    "customer_support": "客户服务",
    "hotline": "热线电话",
    "contact_zalo": "通过 Zalo 联系",
    "send_email": "发送电子邮件",
    "faqs": "常见问题",
    "return_warranty": "退换与保修",
    "genuine_100": "100% 正品保证",
    "genuine_warranty_label": "正品保修标签",
    "return_3_days": "3天内无理由退换",
    "out_of_stock": "状态：联系我们",
    "quantity_left": "库存剩余数量：",
    "add_to_cart": "加入购物车",
    "quantity": "数量",
    "image": "图片",
    "product_name": "产品名称",

    // Cart
    "cart_empty": "您的购物车目前是空的。",
    "login_to_order": "您需要登录后才能下单",
    "no_items_selected": "您尚未选择任何要下单的产品！",
    "insufficient_stock": "产品 {name} 库存不足，仅剩 {qty} 件。",
    "order_success": "下单成功",
    "clear_cart": "清空购物车",
    "place_order": "提交订单",
    "confirm_clear_cart": "确认清空购物车",
    "confirm_clear_cart_msg": "您确定要清空整个购物车吗？",
    "cancel": "取消",
    "clear": "清除",
    "price": "价格",
    "attributes": "属性",
    "no_product_info": "未找到产品信息。",
    "product_unavailable": "此产品不适用于当前账户或站点。",
    "remove_unavailable_product": "请从购物车中删除此产品。",
    "contact_only_product": "此产品目前仅接受联系咨询。",
    "min_qty_warning": "最低数量为1！",
    "max_qty_warning": "最高数量为 ",
    "insufficient_stock_general": "没有足够的库存可添加",
    "total": "总计:",

    // My Orders
    "orders_list": "订单列表",
    "login_to_view_orders": "您尚未登录！请登录后查看订单。",
    "session_expired": "登录已过期。请重新登录！",
    "error_loading_orders": "加载订单时出错: ",
    "cancel_order_failed": "取消订单失败！",
    "cancel_order_success": "订单取消成功！",
    "cancelled": "已取消",
    "state_processing": "正在处理",
    "delivering": "正在配送",
    "completed": "已完成",
    "no_processing_orders": "目前没有正在处理的订单。",
    "no_delivering_orders": "目前没有正在配送的订单。",
    "no_completed_orders": "目前没有已完成的订单。",
    "no_cancelled_orders": "目前没有已取消的订单。",
    "no_orders_yet": "您还没有任何订单。",
    "all": "全部",
    "login_to_view_orders_table": "请登录后查看您的订单列表。",
    "order_code": "订单号",
    "order_date": "下单日期",
    "total_money": "总金额",
    "payment": "支付状态",
    "status": "状态",
    "paid": "已支付",
    "unpaid": "未支付",
    "order_details": "订单详情",
    "order_code_label": "订单号:",
    "product_list": "产品列表:",
    "cancel_order": "取消订单",
    "close": "关闭",
    "confirm_cancel_order": "确认取消订单",
    "confirm_cancel_order_msg": "您确定要取消订单 {id} 吗？",
    "no": "否",
    "yes": "是",

    // Profile & Password
    "full_name": "姓名",
    "phone_number": "电话号码",
    "email_address": "邮箱地址",
    "address": "地址",
    "save_changes": "保存修改",
    "current_password": "当前密码",
    "new_password": "新密码",
    "confirm_new_password": "确认新密码",
    "passwords_do_not_match": "新密码不一致！",

    // Station
    "my_station": "我的搅拌站",
    "station_not_found": "未找到该站点",
    "stations_list": "搅拌站列表",
    "select_station_continue": "请选择搅拌站以继续",

    // Database translations
    "CẢM BIẾN": "传感器",
    "ĐỘNG CƠ HỘP SỐ": "减速电机",
    "THIẾT BỊ ĐIỆN": "电气设备",
    "XILANH KHÍ NÉN": "气缸",
    "HỆ THỐNG CÂN LỌC BỤI": "称重与除尘系统",
    "PHỤ KIỆN TRẠM TRỘN": "搅拌站配件",
    "VẬT LIỆU": "材料",
    "CÁNH TAY BỘ TRỘN": "搅拌臂",
    "PHỤ KIỆN BÊ TÔNG": "混凝土配件",
    "TỦ ĐIỆN ĐIỀU KHIỂN": "控制电柜",
    "CỤM TRUNG TÂM": "中控系统",
    "CỤM BĂNG": "皮带机组",
    "CỤM CỐI": "搅拌机组",
    "CỤM CỐT LIỆU": "配料机组",
    "CỤM SILO": "筒仓机组",
    "TRẠM TRỘN BÊ TÔNG": "混凝土搅拌站",

    "already_have_account_login": "已有账号？立即登录",
    "dont_have_account_register": "还没有账号？立即注册",

    // Missing UI translations
    "location": "位置",
    "failed_to_get_user_stations": "无法获取用户站点",
    "failed_to_get_station_info": "无法获取站点信息",
    "login_to_view_stations": "您需要登录才能显示站点列表。",
    "no_stations_yet": "没有任何站点",
    "station_image": "站点图片",
    "station_name": "站点名称",
    "station_code": "站点代码",
    "product_count": "产品数量",
    "details": "详情",
    "footer_brand_desc": "TTSmart - 领先的混凝土搅拌站自动化、测量设备及物资解决方案。",
    "footer_address": "越南河内市龙边郡越兴坊武德慎街28/29号",
    "connect_with_us": "与我们联系",
    "failed_to_load_profile": "无法加载个人信息",
    "update_failed": "更新失败",
    "update_success": "信息更新成功！",
    "fill_all_address_fields": "请填写完整的地址信息！",
    "failed_to_save_address": "无法保存地址",
    "update_address_success": "地址更新成功！",
    "add_address_success": "地址添加成功！",
    "confirm_delete_address": "您确定要删除此地址吗？",
    "failed_to_delete_address": "无法删除地址",
    "delete_address_success": "地址删除成功！",
    "failed_to_set_default_address": "无法设置默认地址",
    "set_default_address_success": "已设置为默认地址！",
    "account_info": "账户信息",
    "phone_number_used_for_login": "登录账户所使用的电话号码",
    "not_updated_yet": "尚未更新",
    "address_book": "工程/收货地址簿",
    "add_address": "添加地址",
    "no_addresses_saved": "尚未保存任何工程地址。首次下单时输入的地址将自动保存至此处。",
    "receiver": "收件人",
    "edit_construction_address": "编辑工程地址",
    "add_construction_address": "添加新工程地址",
    "address_label_placeholder": "地址标签（例如：工程A、办公室、项目B）",
    "receiver_name": "设备收件人姓名",
    "receiver_phone": "收件人电话号码",
    "address_detail_label": "收货工程详细地址",
    "save_address": "保存地址",
    "passwords_do_not_match_signup": "密码不匹配",
    "phone_validation_msg": "电话号码必须正好是10位数字",
    "email_required_msg": "请输入邮箱",
    "email_validation_msg": "邮箱格式不正确",
    "register_success": "注册成功",
    "login_identifier_required": "请输入手机号或邮箱",
    "login_identifier_invalid": "请输入正确的手机号（10位）或邮箱",
    "login_success": "登录成功",
    "invalid_credentials": "手机号/邮箱或密码不正确",
    "forgot_identifier_required": "请输入手机号或邮箱以找回密码",
    "otp_sent_success": "验证码已发送",
    "otp_invalid": "请输入6位数字验证码",
    "reset_password_success": "密码重置成功",
    "create_account": "创建账户",
    "out_of_stock_val": "联系我们",
    "quantity_left_val": "剩余：",
    "contact_phone": "联系电话: 0813 158 383",
    "add_to_cart_short": "加购物车",
    "password": "密码",
    "confirm_password": "确认密码",
    "register": "注册",
    "forgot_password_title": "找回密码",
    "forgot_password_desc": "请输入您的电话号码或邮箱以接收验证码来重置密码。",
    "phone_or_email": "电话号码或邮箱",
    "otp_email_note": "注意：验证码将发送到客户注册的邮箱中。验证码5分钟内有效！",
    "send_otp": "发送验证码",
    "back_to_login": "返回登录",
    "reset_password_title": "重置密码",
    "otp_sent_to": "验证码已发送至该账户的关联邮箱：",
    "otp_placeholder": "请输入6位数字验证码",
    "confirm_reset": "确认重置",
    "back": "返回",
    "forgot_password": "忘记密码？",
    "welcome": "欢迎！",
    "fill_to_register": "请填写个人信息以创建账户",
    "hello": "您好！",
    "login_to_use_all_features": "请登录以使用我们所有的功能"
  },
  en: {
    // Navbar
    "my_stations_nav": "My Stations",
    "account": "Account",
    "personal_info": "Personal Info",
    "my_orders": "My Orders",
    "change_password": "Change Password",
    "logout": "Log Out",
    "logging_out": "Logging out...",
    "login": "Log In",
    "cart": "Cart",
    "categories": "Categories",
    "home": "Home",
    "station_mixer": "Mixing Station",
    "products": "Products",
    "equipment_group": "Equipment Group",
    "introduction": "Introduction",
    "purchase_policy": "Purchase Policy",
    "contact_us": "Contact Us",
    "dashboard": "Equipment Group",
    "quick_links": "Quick Links",
    "policies": "Policies",
    "copyright": "Copyright © TTSmart. All rights reserved.",

    // Dashboard
    "loading_banner": "Loading banners...",
    "loading_sections": "Loading sections...",
    "loading_partners": "Loading partners...",
    "partners": "Partners",
    "error_prefix": "Error: ",
    "price_unavailable": "Price unavailable",

    // Products / Filters
    "search_products": "Search Products",
    "select_mixing_station": "Select Mixing Station",
    "all_my_stations": "All My Stations",
    "search_by_name": "Search by name",
    "search_by_brand": "Search by Brand",
    "all_brands": "All Brands",
    "search_by_type": "Search by Type",
    "all_types": "All Types",
    "search_by_section": "Search by Section",
    "all_sections": "All Sections",
    "search_by_equipment": "Search by Equipment",
    "all_equipment": "All Equipment",
    "sort_by": "Sort By",
    "created_date": "Created Date",
    "rating": "Rating",
    "purchases": "Purchases",
    "descending": "Descending",
    "ascending": "Ascending",
    "search": "Search",
    "filters": "Filters",
    "product_filters": "Product Filters",
    "login_to_view_station_items": "Please log in to view equipment / materials belonging to your mixing station.",
    "login_now": "Log In Now",
    "no_stations_configured": "Your account has not been assigned any mixing station. Please contact admin for configuration.",
    "no_items_configured": "Your mixing station has not been configured with any equipment, or filters found no matching products.",

    // Product Display
    "loading_product_details": "Loading product details...",
    "product_not_found": "Product not found.",
    "product_does_not_exist": "Product does not exist",
    "failed_to_load_product": "Failed to load product details",
    "failed_to_load_reviews": "Failed to load product reviews",
    "login_to_add_cart": "Please log in to add items to your cart!",
    "login_to_review": "Please log in to review the product!",
    "review_submitted": "Product reviewed successfully",
    "review_updated": "Review updated successfully",
    "review_deleted": "Review deleted successfully!",
    "failed_to_submit_review": "Failed to submit review",
    "failed_to_delete_review": "Failed to delete review",
    "product_description": "Product Description",
    "specifications": "Specifications",
    "reference_documents": "Reference Documents",
    "other_documents": "Other Documents",
    "features": "Features",
    "operating_method": "Operating Method",
    "advantages": "Advantages",
    "no_reviews_yet": "No reviews yet",
    "comment": "Comment",
    "processing": "Processing...",
    "update_review": "Update Review",
    "submit_review": "Submit Review",
    "delete_review": "Delete Review",
    "customer_support": "Customer Support",
    "hotline": "Hotline",
    "contact_zalo": "Contact via Zalo",
    "send_email": "Send Email",
    "faqs": "FAQs",
    "return_warranty": "Return & Warranty",
    "genuine_100": "100% Genuine",
    "genuine_warranty_label": "Genuine warranty label",
    "return_3_days": "3 days return policy",
    "out_of_stock": "Status: Contact",
    "quantity_left": "Quantity left: ",
    "add_to_cart": "Add to Cart",
    "quantity": "Quantity",
    "image": "Image",
    "product_name": "Product Name",

    // Cart
    "cart_empty": "Your cart is currently empty.",
    "login_to_order": "You need to log in to place an order",
    "no_items_selected": "You have not selected any products to order!",
    "insufficient_stock": "Not enough stock for product {name}, only {qty} left.",
    "order_success": "Order placed successfully",
    "clear_cart": "Clear Cart",
    "place_order": "Place Order",
    "confirm_clear_cart": "Confirm Clear Cart",
    "confirm_clear_cart_msg": "Are you sure you want to clear the entire cart?",
    "cancel": "Cancel",
    "clear": "Clear",
    "price": "Price",
    "attributes": "Attributes",
    "no_product_info": "Product information not found.",
    "product_unavailable": "This product is unavailable for the current account or station.",
    "remove_unavailable_product": "Please remove this product from your cart.",
    "contact_only_product": "This product is currently contact-only.",
    "min_qty_warning": "Minimum quantity is 1!",
    "max_qty_warning": "Maximum quantity is ",
    "insufficient_stock_general": "Not enough stock to add more",
    "total": "Total:",

    // My Orders
    "orders_list": "My Orders List",
    "login_to_view_orders": "You are not logged in! Please log in to view orders.",
    "session_expired": "Session expired. Please log in again!",
    "error_loading_orders": "Error loading orders: ",
    "cancel_order_failed": "Failed to cancel order!",
    "cancel_order_success": "Order cancelled successfully!",
    "cancelled": "Cancelled",
    "state_processing": "Processing",
    "delivering": "Delivering",
    "completed": "Completed",
    "no_processing_orders": "No orders are currently in processing.",
    "no_delivering_orders": "No orders are currently in delivery.",
    "no_completed_orders": "No completed orders.",
    "no_cancelled_orders": "No cancelled orders.",
    "no_orders_yet": "You have no orders.",
    "all": "All",
    "login_to_view_orders_table": "Please log in to view your orders.",
    "order_code": "Order ID",
    "order_date": "Order Date",
    "total_money": "Total Price",
    "payment": "Payment Status",
    "status": "Status",
    "paid": "Paid",
    "unpaid": "Unpaid",
    "order_details": "Order Details",
    "order_code_label": "Order ID:",
    "product_list": "Product List:",
    "cancel_order": "Cancel Order",
    "close": "Close",
    "confirm_cancel_order": "Confirm Cancel Order",
    "confirm_cancel_order_msg": "Are you sure you want to cancel the order {id}?",
    "no": "No",
    "yes": "Yes",

    // Profile & Password
    "full_name": "Full Name",
    "phone_number": "Phone Number",
    "email_address": "Email Address",
    "address": "Address",
    "save_changes": "Save Changes",
    "current_password": "Current Password",
    "new_password": "New Password",
    "confirm_new_password": "Confirm New Password",
    "passwords_do_not_match": "New passwords do not match!",

    // Station
    "my_station": "My Station",
    "station_not_found": "Station not found",
    "stations_list": "Mixing Stations List",
    "select_station_continue": "Please select a mixing station to continue",

    // Database translations
    "CẢM BIẾN": "Sensor",
    "ĐỘNG CƠ HỘP SỐ": "Gear Motor",
    "THIẾT BỊ ĐIỆN": "Electrical Equipment",
    "XILANH KHÍ NÉN": "Pneumatic Cylinder",
    "HỆ THỐNG CÂN LỌC BỤI": "Weighing & Dust Filtration System",
    "PHỤ KIỆN TRẠM TRỘN": "Mixing Station Accessories",
    "VẬT LIỆU": "Materials",
    "CÁNH TAY BỘ TRỘN": "Mixer Arm",
    "PHỤ KIỆN BÊ TÔNG": "Concrete Accessories",
    "TỦ ĐIỆN ĐIỀU KHIỂN": "Control Panel",
    "CỤM TRUNG TÂM": "Central System",
    "CỤM BĂNG": "Belt Conveyor Group",
    "CỤM CỐI": "Mixer Group",
    "CỤM CỐT LIỆU": "Aggregate Group",
    "CỤM SILO": "Silo Group",
    "TRẠM TRỘN BÊ TÔNG": "Concrete Mixing Plant",

    "already_have_account_login": "Already have an account? Login now",
    "dont_have_account_register": "Don't have an account? Register now",

    // Missing UI translations
    "location": "Location",
    "failed_to_get_user_stations": "Failed to get user stations",
    "failed_to_get_station_info": "Failed to get station information",
    "login_to_view_stations": "You need to log in to display your stations.",
    "no_stations_yet": "No stations found",
    "station_image": "Station Image",
    "station_name": "Station Name",
    "station_code": "Station Code",
    "product_count": "Product Count",
    "details": "Details",
    "footer_brand_desc": "TTSmart - Leading automation, measurement equipment, and materials solution for concrete mixing stations.",
    "footer_address": "No. 28/29 Vu Duc Than, Viet Hung, Long Bien, Hanoi, Vietnam",
    "connect_with_us": "Connect with us",
    "failed_to_load_profile": "Failed to load profile details",
    "update_failed": "Update failed",
    "update_success": "Profile updated successfully!",
    "fill_all_address_fields": "Please fill out all address fields!",
    "failed_to_save_address": "Failed to save address",
    "update_address_success": "Address updated successfully!",
    "add_address_success": "Address added successfully!",
    "confirm_delete_address": "Are you sure you want to delete this address?",
    "failed_to_delete_address": "Failed to delete address",
    "delete_address_success": "Address deleted successfully!",
    "failed_to_set_default_address": "Failed to set default address",
    "set_default_address_success": "Set as default address!",
    "account_info": "Account Information",
    "phone_number_used_for_login": "Phone number used as login username",
    "not_updated_yet": "Not updated",
    "address_book": "Construction/Delivery Address Book",
    "add_address": "Add Address",
    "no_addresses_saved": "No construction addresses saved yet. The address entered during your first order will be saved here.",
    "receiver": "Receiver",
    "edit_construction_address": "Edit Construction Address",
    "add_construction_address": "Add New Construction Address",
    "address_label_placeholder": "Address label (e.g., Project A, Office, Project B)",
    "receiver_name": "Equipment Receiver Name",
    "receiver_phone": "Receiver Phone Number",
    "address_detail_label": "Detailed construction/delivery address",
    "save_address": "Save Address",
    "passwords_do_not_match_signup": "Passwords do not match",
    "phone_validation_msg": "Phone number must be exactly 10 digits",
    "email_required_msg": "Please enter your email",
    "email_validation_msg": "Invalid email format",
    "register_success": "Registration successful",
    "login_identifier_required": "Please enter your phone number or email",
    "login_identifier_invalid": "Please enter a valid phone number (10 digits) or email address",
    "login_success": "Login successful",
    "invalid_credentials": "Incorrect phone/email or password",
    "forgot_identifier_required": "Please enter your phone number or email",
    "otp_sent_success": "OTP code sent successfully",
    "otp_invalid": "Please enter a 6-digit OTP code",
    "reset_password_success": "Password reset successfully",
    "create_account": "Create Account",
    "out_of_stock_val": "Contact",
    "quantity_left_val": "Left: ",
    "contact_phone": "Contact: 0813 158 383",
    "add_to_cart_short": "Add",
    "password": "Password",
    "confirm_password": "Confirm Password",
    "register": "Register",
    "forgot_password_title": "Forgot Password",
    "forgot_password_desc": "Enter your phone number or email address to receive an OTP code to reset your password.",
    "phone_or_email": "Phone Number or Email",
    "otp_email_note": "Note: The OTP code will be sent to the registered email. The code is valid for 5 minutes!",
    "send_otp": "Send OTP Code",
    "back_to_login": "Back to Login",
    "reset_password_title": "Reset Password",
    "otp_sent_to": "The OTP code has been sent to the linked email of this account:",
    "otp_placeholder": "Enter 6-digit OTP code",
    "confirm_reset": "Confirm Reset",
    "back": "Back",
    "forgot_password": "Forgot password?",
    "welcome": "Welcome!",
    "fill_to_register": "Please fill out your details to create an account",
    "hello": "Hello!",
    "login_to_use_all_features": "Please log in to use all of our features"
  }
};

export const translations = {
  vi: { ...baseTranslations.vi, ...customerTranslations.vi },
  zh: { ...baseTranslations.zh, ...customerTranslations.zh },
  en: { ...baseTranslations.en, ...customerTranslations.en },
};

